const Choices = require('choices.js');

/*
* This inits the custom selects managed by Choices.js
* in the element passed as argument (whole document if nothing passed)
* the inited instances are stored in window.initedChoicesInstances global variable
*/
const initCustomSelect = function (container = document) {
    window.initedChoicesInstances = window.initedChoicesInstances || [];
    const customSelects = container.querySelectorAll('.custom-select');

    for (const customSelect of customSelects) {
        let additionnalClasses = '';
        for (const currentClass of customSelect.classList.values()) {
            if (currentClass.startsWith('custom-choices')) {
                additionnalClasses = ` ${currentClass}`;
                break;
            }
        }

        if (!customSelect.classList.contains('choices__input')) { // Prevent re-init of already inited custom selects
            if (customSelect.classList.contains('has-icon')) { // Custom select with icons used in find in store
                // callbackOnCreateTemplates function is inspired by the inline <script> in https://choices-js.github.io/Choices/
                window.initedChoicesInstances.push(new Choices(customSelect, {
                    allowHTML: true,
                    shouldSort: false,
                    searchEnabled: customSelect.dataset.hasSearch !== undefined,
                    itemSelectText: '',
                    classNames: {
                        containerOuter: `choices choices-icon${additionnalClasses}`,
                    },
                    ariaState: {
                        ariaIsSelected: 'aria-selected',
                        ariaDisabled: 'aria-disabled',
                        ariaExpanded: 'aria-expanded',
                        ariaHaspopup: 'aria-haspopup',
                    },
                    position: customSelect.dataset.position || 'auto',
                    callbackOnCreateTemplates(strToEl) {
                        const { classNames } = this.config; // eslint-disable-line no-unused-vars
                        const { itemSelectText } = this.config; // eslint-disable-line no-unused-vars
                        return {
                            item({ classNames }, data) { // eslint-disable-line no-shadow
                                return strToEl(
                                    `<div class="${
                                        String(classNames.item)
                                    } ${
                                        String(
                                            data.highlighted
                                                ? classNames.highlightedState
                                                : classNames.itemSelectable,
                                        )}" data-item data-id="${
                                        String(data.id)
                                    }" data-value="${String(data.value)}"${
                                        String(data.active ? 'aria-selected="true"' : '')
                                    } ${String(data.disabled ? 'aria-disabled="true"' : '')
                                    }><img class="mr-12 d-inline-block" width="24" height="24" src="${this.passedElement.element.dataset.iconSrc}" alt /><span class="choices__value"">${
                                        String(data.label)}</span></div>`,
                                );
                            },
                            input: (...args) => {
                                const input = Choices.defaults.templates.input.call(this, ...args);
                                input.setAttribute('aria-label', customSelect.dataset.inputAriaLabel || '');
                                return input;
                            },
                        };
                    },
                }));
            } else {
                var actualSelect = customSelect;
                // Standard custom select
                window.initedChoicesInstances.push(new Choices(
                    customSelect,
                    {
                        allowHTML: true,
                        shouldSort: false,
                        searchEnabled: customSelect.dataset.hasSearch !== undefined,
                        itemSelectText: '',
                        classNames: {
                            containerOuter: `choices${additionnalClasses}`,
                        },
                        callbackOnInit() { // eslint-disable-line no-loop-func
                            if (actualSelect.disabled) {
                                this.disable();
                            }
                        },
                    },
                ));
            }
        }
    }
};

/*
* This returns an inited Choice.js instance from window.initedChoicesInstances
*/
const getInstanceFromId = function (id) {
    for (const initedInstance of window.initedChoicesInstances) {
        if (initedInstance.passedElement && initedInstance.passedElement.element && initedInstance.passedElement.element.id === id) { // eslint-disable-line no-underscore-dangle
            return initedInstance;
        }
    }
    return null;
};

/*
* This destroys an inited Choice.js instance and remove it from window.initedChoicesInstances
* return {Boolean} success or failure
*/
const destroyInstanceFromId = function (id) {
    const instance = getInstanceFromId(id);
    if (instance) {
        const indexOfInstance = window.initedChoicesInstances.indexOf(instance);
        instance.destroy();
        window.initedChoicesInstances.splice(indexOfInstance, 1); // remove instance from window.initedChoicesInstances
        return true;
    }
    return false;
};

module.exports = {
    initCustomSelect,
    getInstanceFromId,
    destroyInstanceFromId,
};
